
export type GetProfileByUsername200SocialLinks = {
  github?: string;
  linkedin?: string;
  twitter?: string;
};
